import React from 'react';
import { Alert, Box } from '@mui/material';
import { UnifiedHoursEditor } from '../../StoreHours/UnifiedHoursEditor';
import { AVAILABLE_OCCASIONS, type BulkHoursEditorProps } from './types';

export const BulkHoursEditor: React.FC<BulkHoursEditorProps> = ({ onChange }) => {
  return (
    <Box sx={{ p: 1 }}>
      <Alert severity="info" sx={{ mb: 2 }}>
        Click & Collect and Delivery hours are saved separately. In Manage All Hours, Delivery
        copies Click & Collect unless you set it to Override.
      </Alert>
      <UnifiedHoursEditor
        availableOccasions={AVAILABLE_OCCASIONS}
        onChange={onChange}
        showTemplates={true}
        showSpecialHours={false}
      />
    </Box>
  );
};
